import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';

// ==============================|| GUEST GUARD ||============================== //
// Girişi olan kullanıcı /login'e giderse Ana Sayfa'ya yönlendirir.

export default function GuestGuard({ children }) {
  const { isLoggedIn } = useAuth();

  if (isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  return children;
}

GuestGuard.propTypes = { children: PropTypes.node };
